module.exports = "$(document).ready(function(){$(\"#dataTable\").DataTable()});"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/startbootstrap-sb-admin/js/sb-admin-datatables.min.js
// module id = XYV+
// module chunks = 0